module.exports = __webpack_public_path__ + "media/images/boxes/webchat-box143-23618b5a753eedcb9f49ee562c37a8b0.png";